module.exports = __webpack_public_path__ + "static/media/2en.3ac00cb1.jpg";